import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { saveSelectedEnrolment } from '../../../../actions/hub/hubContactPageActions';
import { fetchUpcomingSessionsWithSTPH } from '../../../../actions/hub/hubSessionsPageActions';

export default function useInitializeData() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchUpcomingSessionsWithSTPH());

    return () => {
      // clear the selected enrolment when the component unmounts
      dispatch(saveSelectedEnrolment({ enrolmentId: '' }));
    };
  }, [dispatch]);
}
